import { coreFields } from "./helpers/coreFields";

export default {
  title: "bs_images",
  exportFileName: "bs_images",
  source: "bs_images",
  apiPath: "",
  forms: {
    default: {
      fields: []
    }
  },
  listViews: {
    default: {
      fields: []
    }
  },
  fields: [
    coreFields.id,
    {
      title: "Title",
      source: "title",
      type: "text"
    },
    {
      title: "image",
      source: "image",
      ttoken: "vozilaImages.image",
      type: "images",
      maxFiles: 1,
      width: "full"
    }
  ]
};
